'use client';

import React, { useEffect } from 'react';
import useCurrentPerpMarketAccount from '../../hooks/useCurrentPerpMarketAccount';
import StatusBar from 'src/components/primitives/StatusBar/StatusBar';
import Link from 'src/components/primitives/Link/Link';
import { DRIFT_DISCORD_URL } from '../../constants/constants';
import useInfoForCurrentlySelectedMarket from '../../hooks/useInfoForCurrentlySelectedMarket';

enum MarketBannerStatus {
	DEFAULT,
	VAMM_DISABLED,
}

const MarketStatusBanner = () => {
	const currentlySelectedMarketInfo = useInfoForCurrentlySelectedMarket();
	const currentlySelectedPerpMarket = useCurrentPerpMarketAccount();

	const [marketStatus, setMarketStatus] = React.useState<MarketBannerStatus>(
		MarketBannerStatus.DEFAULT
	);

	useEffect(() => {
		if (!currentlySelectedPerpMarket) {
			setMarketStatus(MarketBannerStatus.DEFAULT);
			return;
		}

		setMarketStatus(MarketBannerStatus.DEFAULT);
	}, [currentlySelectedPerpMarket]);

	if (marketStatus !== MarketBannerStatus.VAMM_DISABLED) {
		return null;
	}

	return (
		<StatusBar variant="info">
			AMM trades have been paused for{' '}
			{currentlySelectedMarketInfo?.info?.config?.symbol}. Users can continue to
			trade against one another. Settling P&L has been temporarily disabled. For
			the latest updates,{' '}
			<Link
				className="text-white hover:text-white"
				href={DRIFT_DISCORD_URL}
				openInNewTab
			>
				visit our discord
			</Link>
			.
		</StatusBar>
	);
};

export default MarketStatusBanner;
